import React, { FC } from "react";
import { CampaignsView } from "../components";

export const CampaignsPage: FC = () => {
  return <CampaignsView />;
};
